import { i18n } from "../../../../../language";

const $menuT = (that, key) => {
    if (that && that.$t) {
        return that.$t(key);
    }
    return i18n.t(key);
};

const MENU_TYPES = {
    EXTENSIONS: "extensions",
    EXTENSION_MAPPING: "extension-mapping",
    WEBHOOKS: "webhooks",
    CDR: "cdr",
    AUTOMATIONS: "automations",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.EXTENSIONS,
        label: $menuT(that, "menu.extensions"),
        icon: {
            type: "material-icons",
            name: "phone",
        },
        group: $menuT(that, "menu.mainSettings"),
    },
    {
        enabled: true,
        key: MENU_TYPES.EXTENSION_MAPPING,
        label: $menuT(that, "menu.extensionMapping"),
        icon: {
            type: "material-icons",
            name: "link",
        },
        group: $menuT(that, "menu.mainSettings"),
    },
    {
        enabled: true,
        key: MENU_TYPES.WEBHOOKS,
        label: $menuT(that, "menu.webhooks"),
        icon: {
            type: "material-icons",
            name: "webhook",
        },
        group: $menuT(that, "menu.mainSettings"),
    },
    {
        enabled: true,
        key: MENU_TYPES.CDR,
        label: $menuT(that, "menu.cdrCallRecords"),
        icon: {
            type: "material-icons",
            name: "call",
        },
        group: $menuT(that, "menu.reports"),
    },
    {
        enabled: true,
        key: MENU_TYPES.AUTOMATIONS,
        label: $menuT(that, "menu.automations"),
        icon: {
            type: "component",
            name: "AutomationIcon",
            class: "myIcon",
            style: { fill: "var(--color-icon-primary-default)" },
        },
        group: $menuT(that, "menu.mainSettings"),
    },
];

export default {
    MENU_TYPES,
    Items,
};
